module.exports = __webpack_public_path__ + "static/img/index-video.b1bd0c36.png";